import Icon from '../components/Icon.vue'

Icon.register({
  joint: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M444.3 181.1c-35.8-25.1-60.3-63-60.3-106.7v-66.4c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v62.3c0 29 15.8 54.7 39.7 71.3 35.3 24.7 56.3 64.8 56.3 108.1v30.3c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-30.3c0-27.4-13.3-52.9-35.7-68.6zM195 359c22.4-3.6 45.1 4.3 59.8 21.5l112.7 131.5h-88.6c-98.6 0-195.3-27.7-278.9-80 59.7-37.3 126-61.9 195-73zM553.3 87.1c54.3 36.4 86.7 97.2 86.7 162.6v30.3c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-30.3c0-50.2-25.2-96.7-67.4-124-18.5-12-28.6-33.4-28.6-55.4v-62.3c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v62.3c0 6.8 3.6 13 9.3 16.8zM360.9 352h0.1c16.2 0 38 10 48.6 22.4l117.9 137.6h-88.4 0c-16.2 0-38-10-48.6-22.3l-117.8-137.4c1.4 0 53.8-0.1 88.2-0.2zM616 352c13.3 0 24 10.7 24 24v112c0 13.3-10.8 24-24 24h-17.4 0c-16.2 0-38-10-48.6-22.3l-118-137.7h184z'
      }
    ]
  }
})
